import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "layout-production__nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nav_tabs = _resolveComponent("nav-tabs")!
  const _component_rotate_device = _resolveComponent("rotate-device")!
  const _component_layout_default = _resolveComponent("layout-default")!

  return (_openBlock(), _createBlock(_component_layout_default, _mergeProps({ class: "layout-production" }, _ctx.layoutProps), {
    "header-tools": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_nav_tabs, { items: _ctx.navItems }, null, 8, ["items"])
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(_component_rotate_device)
    ]),
    _: 3
  }, 16))
}